var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('newTrainingSubmission',{attrs:{"trainingModule":_vm.trainingModule,"credentialRequirement":_vm.credentialRequirement}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }